import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=86d3450e&scoped=true"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js"
import style0 from "./ImpersonationBanner.vue?vue&type=style&index=0&id=86d3450e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d3450e",
  null
  
)

export default component.exports